// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    PhoneIncoming,
    PhoneMissed,
    PhoneOff,
    PhoneOutgoing,
    Pi,
    Piano,
    Pickaxe,
    PictureInPicture,
    PictureInPicture2,
    PiggyBank,
    Pilcrow,
    PilcrowLeft,
    PilcrowRight,
    Pill,
    PillBottle,
    Pin,
    PinOff,
    Pipette,
    Pizza,
    Plane,
    PlaneLanding,
    PlaneTakeoff,
    Play,
    PlayOff,
    PlayingCard,
    PlayingCards,
    PlayingCardsFan,
    Plug,
    Plug2,
    PlugZap,
    Plus,
    PocketKnife,
    Podium,
    Pointer,
    PointerOff,
    Popcorn,
    Popsicle,
    PoundSterling,
    Power,
    PowerOff,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "phone-incoming" through "power-off", inclusive. */
const shard: Record<string, LucideIcon> = {
    "phone-incoming": PhoneIncoming,
    "phone-missed": PhoneMissed,
    "phone-off": PhoneOff,
    "phone-outgoing": PhoneOutgoing,
    pi: Pi,
    piano: Piano,
    pickaxe: Pickaxe,
    "picture-in-picture": PictureInPicture,
    "picture-in-picture-2": PictureInPicture2,
    "piggy-bank": PiggyBank,
    pilcrow: Pilcrow,
    "pilcrow-left": PilcrowLeft,
    "pilcrow-right": PilcrowRight,
    pill: Pill,
    "pill-bottle": PillBottle,
    pin: Pin,
    "pin-off": PinOff,
    pipette: Pipette,
    pizza: Pizza,
    plane: Plane,
    "plane-landing": PlaneLanding,
    "plane-takeoff": PlaneTakeoff,
    play: Play,
    "play-off": PlayOff,
    "playing-card": PlayingCard,
    "playing-cards": PlayingCards,
    "playing-cards-fan": PlayingCardsFan,
    plug: Plug,
    "plug-2": Plug2,
    "plug-zap": PlugZap,
    plus: Plus,
    "pocket-knife": PocketKnife,
    podium: Podium,
    pointer: Pointer,
    "pointer-off": PointerOff,
    popcorn: Popcorn,
    popsicle: Popsicle,
    "pound-sterling": PoundSterling,
    power: Power,
    "power-off": PowerOff,
};

export default shard;
